<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <!--    <custom-popup v-model="ready" :cons="{title:'نمونه فروشگاه‌های آنلاین آماده'}" hide-confirm hide-overlay-->
        <!--                  max-width="900" transition="dialog-bottom-transition">-->
        <!--      <v-card class="p-5" flat>-->
        <!--        <prepared-cards :value="cardTexts" type="bShop" @closeModel="ready = false" @input="savePageTemplate"/>-->
        <!--      </v-card>-->
        <!--    </custom-popup>-->

        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>
            <v-tab :ripple="true"> پیش نمایش </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
              <div class="rowinfo">
                <v-btn
                  class="btn-download contentinfo"
                  @click="showDialog = true"
                >
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-download-btn`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                />
              </div>
            </v-tab-item>

            <v-tab-item>
              <view-shop v-model="cardTexts" />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'insurance'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>ساخت کیوآر</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo" cols="12">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام بیمه آنلاین"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام بیمه آنلاین"
                  />
                </div>

                <div
                  class="col-md-6 mt-0 pt-0 rowinfo"
                  style="width: 100% !important"
                >
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contnetinfo"
                    style="flex: 1 1 auto !important"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >محصولات و اطلاعات</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="d-flex align-center mb-4">
                <div class="d-flex row mx-0 mt-4">
                  <div class="rowinfo">
                    <v-btn
                      :disabled="e6 > 2"
                      color="third"
                      outlined
                      @click="clearDefaults"
                      class="contentinfo"
                    >
                      <v-icon class="me-2">mdi-delete</v-icon>
                      حذف اطلاعات پیشفرض
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-clearDefaults`"
                      label="حذف اطلاعات پیش‌فرض"
                      :service-name="serviceName"
                      :help-data="helpData"
                    />
                  </div>
                </div>

                <!--            <v-btn :loading="templateLoading" class="btn-download" depressed @click="ready = true">-->
                <!--              انتخاب فروشگاه آنلاین آماده-->
                <!--            </v-btn>-->

                <v-spacer />
                <!--            <v-card-actions v-if="!!cardTexts.product && cardTexts.product.onlineShop" class="justify-end">-->
                <!--              <v-switch v-model="cardTexts.product.onlineShop" class="ma-0" dense hide-details inset-->
                <!--                        label="فروش آنلاین"/>-->
                <!--            </v-card-actions>-->
              </div>

              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6 = 3"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 3" class="px-0 px-md-4" step="3"
              >تنظیمات محتوا</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo2"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 2" />
                </div>

                <div class="col-md-6">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate"
                  />
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 4" class="px-0 px-md-4" step="4"
              >تنظیمات فروش</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="4">
              <!--          <qr-management ref="qrManage" :qr-domain="createdDomain" :qrId="createdId"/>-->
              <qr-shop-manager ref="qrShop" :qr-id="createdId" />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 3" />
                </div>

                <div class="col-md-6">
                  <!--              <next-btn :loading="loading" @click="setSettings"/>-->
                  <next-btn :loading="loading" @click="updateShopSettings" />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              v-if="e6 > 1"
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
            <div class="rowinfo">
              <download-file-with-api
                v-if="showDialog"
                class="contentinfo"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                :qr_id="info.qrId"

              />
              <help-info
                :element-name="`${serviceName}-${componentName}-download-file`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="نام بیمه آنلاین"
              />
            </div>
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake";
import { mapActions, mapState } from "vuex";
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop.vue";
import StoreShopContent from "@/utilities/StoreShopContent";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";

export default {
  name: "createInsurance",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrShopManager,
    PreparedCards,
    QrCodeMake,
    ViewShop,
    DownloadFileWithApi,
    QrMaker,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    Tariffs
  },

  provide: {
    productImageSize: "128",
  },

  data() {
    return {
      helpData: [],
      componentName: "insurance-create",
      serviceName: "Qrland",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      // ready: false,
      errors: {},
      createdDomain: null,
      createdId: null,
      info: null,
      loading: false,
      templateLoading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "shopLoginConfig",
          value: "",
          title: "تنظیمات ورود",
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: "لوگو و تصاویر فروشگاه",
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo",
              model: "shopLogo",
            },
            {
              title: "اطلاعات صفحه ورود",
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود بنر",
          subtitle: "",
          icon: "image",
          model: "banner",
        },
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
        // {name: 'Product', value: '', title: 'ایجاد محصول', subtitle: '', icon: 'sign-yield', model: 'product', arm: []},
        {
          name: "InsuranceManage",
          value: "",
          title: "مدیریت بیمه‌ها",
          subtitle: "",
          icon: "shield-account-outline",
          model: "insurance",
        },
        {
          name: "specialCategoryManager",
          value: "",
          title: "فروش ویژه",
          subtitle: "",
          icon: "star-box-outline",
          model: "specialCategories",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        { name: "Blog", value: "", title: "بلاگ", subtitle: "", icon: "text" },
        {
          name: "Service",
          value: "",
          title: "خدمات",
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "سوالات متداول",
          subtitle: "",
          icon: "help",
          model: "faq",
        },
      ],
      specialInfo2: [
        {
          name: "PicSelector",
          value: "",
          title: "گالری عکس",
          subtitle: "",
          icon: "image",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "گالری پی دی اف ",
          subtitle: "",
          icon: "file",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply",
          model: "FeedBack",
        },
        {
          name: "Counter",
          value: "",
          title: "شمارنده معکوس",
          subtitle: "",
          icon: "timer",
          model: "Counter",
        },
        {
          name: "consultation",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultation",
        },
        {
          name: "ServiceSection",
          value: "",
          title: "ایجاد بخش",
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: "موفقیت های بدست آمده",
          subtitle: "",
          icon: "post",
          model: "CounterService",
        },
        {
          name: "Personnel",
          value: "",
          title: "اعضای تیم",
          subtitle: "",
          icon: "account-multiple",
          model: "personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "تایم کاری",
          subtitle: "",
          icon: "timer",
          model: "WorkSheet",
        },
      ],
      dtUrl: null,
      domainId: "",
      cardTexts: {
        shopLoginConfig: {
          shopLogo: [
            {
              value: "logo",
              name: "لوگو",
              logo: "",
            },
            {
              value: "background",
              name: "تصویر پس‌زمینه",
              background: "",
            },
          ],
          configs: {
            subtitle: "",
          },
        },
        banner: {
          gallery: [
            {
              name: "",
              images: [
                {
                  name: "28",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 17534,
                },
                {
                  name: "32",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 17535,
                },
              ],
            },
          ],
        },
        consultation: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          items: {
            name: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام",
            },
            surname: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام خانوادگی",
            },
            phone: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "شماره موبایل",
            },
            mail: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "ایمیل",
            },
            address: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "آدرس",
            },
            nationalId: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "کدملی",
              verify: "correct",
            },
            location: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "لوکیشن",
            },
            custom: {
              is_active: false,
              type: "optional",
              value: "",
              format: "select",
              extra: {
                label: "",
                options: [],
              },
            },
            description: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "توضیحات",
            },
          },
        },
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        personnel: {
          items: [],
        },
        WorkSheet: {
          items: {
            saturday: {
              name: "شنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            sunday: {
              name: "یکشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            monday: {
              name: "دوشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            tuesday: {
              name: "سه‌شنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            wednesday: {
              name: "چهارشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "14:00",
                },
                {
                  start: "17:00",
                  end: "21:00",
                },
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            thursday: {
              name: "پنجشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "12:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            friday: {
              name: "جمعه",
              shift: [{}, {}],
            },
          },
        },
        Counter: {
          title: "متفاوت خواهیم شد...",
          description:
            "در مسیری درست، همیشه کوشا هستیم تا بهترین خود باشیم >>> برای شما",
          until: "2026-03-21 00:00:00",
          type: "countdown_2",
        },
        insurance: {
          title: "بیمه‌ها",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
          onlineShop: true,
        },
        specialCategories: {
          title: "فروش ویژه",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        visitName: "",
        organizationName: "کیوآر لند",
        subOrgan: "فروشگاه آنلاین شما 15 دقیقه ای آمادست!",
        userName: "خانم صفدریان",
        workField: "مدیریت فروش",
        phoneNumber: [
          {
            number: "90007425",
          },
          {
            number: "02191017077",
          },
          {
            number: "09999903535",
          },
        ],
        extraFields: [
          {
            icon: "",
            name: "",
            value:
              "مشتری عزیز شما می توانید از سایر فروشگاه های آنلاین ما نیز خرید کنید:",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت دیوار",
            link: "www.divar.ir",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت دیجی کالا",
            link: "www.digikala.com",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت باسلام",
            link: "www.basalam.com",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت ترب",
            link: "www.torob.com",
          },
          {
            icon: "mdi-chevron-triple-left",
            name: "",
            value: "سایت ایمالز",
            link: "www.emalls.ir",
          },
        ],
        companyNumber: "02191017077",
        email: "9100terminalads@gmail.com",
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
        city: "",
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.terminalads.com",
        socialMedia: {
          address: [
            {
              label: "آدرس",
              text: "لینک سایت مورد نظر را وارد نمایید",
              pattern: "",
              prefix: "URL",
              url: "qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
          ],
          instagram: [
            {
              label: "اینستاگرام",
              text: "نام کاربری خود را وارد نمایید",
              pattern: "https://instagram.com/",
              prefix: "@",
              url: "terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
            },
          ],
          whatsapp: [
            {
              label: "واتساپ",
              text: "+989123456789",
              pattern: "https://wa.me/",
              prefix: "mdi-phone",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
            },
          ],
        },
        aboutUs:
          'با افتخار فروشگاه‌سازی حرفه‌ای و کارآمد را برای کسب‌وکار‌های آنلاین ارائه داده ایم.\nبدون نیاز به دانش فنی، به‌ صورت کاملاً رایگان، می‌توانید فروشگاه اینترنتی خود را ایجاد کنید.\nما به شما امکاناتی مانند مدیریت محصولات، پرداخت آنلاین، و پیگیری سفارشات را فراهم می‌کنیم.\nهمچنین، پشتیبانی اختصاصی و راهکارهای جذب مشتریان را نیز ارائه می‌دهیم.\n\nاگر نیاز به تنظیمات خاصی دارید یا سایر جزئیات را می‌خواهید، \nلطفاً به نیازهای کسب‌وکار خود بپردازید و متن "درباره ما" را به‌صورت مناسب تغییر دهید.',
        copyright: "تمامی حقوق این سایت متعلق به کیوآر لند می باشد.",
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
            text: "#fff",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: null,
          description: null,
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        CounterService: {
          title: "دستاوردهای مجوعه ما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [
            {
              type: "percent",
              counter: "97",
              name: "رضایت مشتریان",
              icon: "mdi-account",
              link: "",
            },
            {
              type: "percent",
              counter: "4",
              name: "کمترین بازگشتی",
              icon: "mdi-backup-restore",
              link: "",
            },
            {
              type: "number",
              counter: "20000",
              name: "مشتری وفادار",
              icon: "mdi-account-box-multiple",
              link: "",
            },
            {
              type: "number",
              counter: "145485",
              name: "سفارش ارسال شده",
              icon: "mdi-archive-check",
              link: "",
            },
          ],
        },
        PicSelector: {
          title: null,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "از ویدئوهای مجموع ما دیدن فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        ServiceSection: {
          title: null,
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [
            {
              section: {
                title: "",
                text: null,
                button: {
                  show: false,
                  title: "یک خرید راحت",
                  icon: "mdi-monitor-cellphone",
                  background:
                    "linear-gradient(to right , #1AD0D8FF, #2115A7FF)",
                  color: "#ffffffff",
                  link: "https://my.qrland.ir/003#/",
                  target: "_blank",
                },
                text_position: "left",
                object: {
                  type: "image",
                  url: "",
                },
              },
            },
          ],
        },
        faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            gallery: [
              {
                name: "گالری عکس",
                images: [],
              },
            ],
          },
          sectionColor: {
            backGround: "linear-gradient(to right , #FF000062, #FF000075)",
            text: "#fff",
          },
          items: [
            {
              question: "1. چطوری می تونم سفارش خودم رو ثبت کنم ؟",
              answer: "کافیست محصولات مورد نظر خود را به سبد خرید اضافه کنید.",
            },
            {
              question: "2. چگونه می توانم در سایت ثبت نام کنم؟",
              answer:
                'کافیست بر روی دکمه "ورود" کلیک کنید و پس از وارد کردن شماره همراه، کد پیامک شده را نیز وارد کنید.',
            },
            {
              question:
                "3. پس از اینکه سفارشم رو ثبت کردم چقدر طول می کشه به دستم برسه؟",
              answer: "در سریع ترین زمان ممکن سفارش شما ارسال خواهد شد.",
            },
            {
              question: "4. هزینه ارسال سفارش چقدر هست؟",
              answer: "هزینه ارسال سفارش نسبت به آدرس شما متغییر خواهد بود.",
            },
            {
              question:
                "5. آیا می تونم بعد از ثبت سفارش، محصولمو تغییر بدم یا کنسل کنم ؟",
              answer: "خیر.\nامکان تغییر یا لغو وجود ندارد.",
            },
          ],
        },
        Service: {
          title: "بهترین ها را برای شما به ارمغان آورده ایم...",
          slider: false,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما برای ما مهم است",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "emoji",
          items: [
            {
              question: "آیا از کیفیت کالاها رضایت داشتید؟",
              answer: "",
              type: "emoji",
              value: null,
              description: true,
              forceDesc: false,
            },
            {
              question: "کیفیت بسته بندی را چگونه ارزیابی می کنید؟",
              answer: "",
              type: "emoji",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "آیا از تنوع کالاها راضی بودید؟",
              answer: "",
              type: "emoji",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "آیا از تخفیفات این فروشگاه هم بهره ‎مند شده ‎اید؟",
              answer: "",
              type: "emoji",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "برای بهبود تجربه‎ خرید از این فروشگاه چه پیشنهادی دارید؟",
              answer: "",
              type: "emoji",
              value: null,
              description: true,
              forceDesc: true,
            },
          ],
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
        pdf: [
          {
            name: "گالری پروپزال‌های کیوآرلند",
            images: [
              {
                title: "پروپزال معرفی محصول",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
                url: "media/productpro.webp",
                description:
                  "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
                selected: true,
              },
              {
                title: "پروپزال کارت ویزیت الکترونیکی",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
                url: "media/cardvisit.webp",
                description:
                  "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
                selected: true,
              },
            ],
          },
        ],
        blog: [],
        service: [
          {
            title: "پست 1",
            content: "ارسال سریع سفارش",
            icon: "mdi-truck-fast",
            gallery: [
              {
                name: "",
                images: [],
              },
            ],
            color: null,
          },
          {
            title: "پست 2",
            content: "امکان پرداخت در محل",
            icon: "mdi-account-credit-card",
            gallery: [
              {
                name: "",
                images: [],
              },
            ],
            color: null,
          },
          {
            title: "پست 3",
            content: "ضمانت اصالت کالا",
            icon: "mdi-shield-check",
            gallery: [
              {
                name: "",
                images: [],
              },
            ],
            color: null,
          },
        ],
        gallery: [
          {
            name: "گالری عکس",
            images: [
              {
                name: "34",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17536,
              },
              {
                name: "35",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17537,
              },
              {
                name: "36",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 17538,
              },
            ],
          },
        ],
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                file_link:
                  "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                description: "",
                link: "",
                id: 15,
              },
            ],
          },
        ],
      },
      qrShow: 1,
      qrSvgDataUrl: "",
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts.gallery[0].images[0].url = this.gallery_1;
    this.cardTexts.gallery[0].images[1].url = this.gallery_2;
    this.cardTexts.gallery[0].images[2].url = this.gallery_3;
    this.cardTexts.cardTexts.gallery[0].images[0].url = this.banner_1;
    this.cardTexts.cardTexts.gallery[0].images[1].url = this.banner_2;
    this.cardTexts.ServiceSection.items[0].object.url = this.image_1;

    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    image_1() {
      return this.$cdnUrl + "/upload/666d5c59898ed.webp";
    },
    banner_1() {
      return this.$cdnUrl + "/upload/6676afc9ddf26.webp";
    },
    banner_1() {
      return this.$cdnUrl + "/upload/6676afd1cdc70.webp";
    },
    gallery_1() {
      return this.$cdnUrl + "/upload/6676afd6ecb43.webp";
    },
    gallery_2() {
      return this.$cdnUrl + "/upload/6676afdcdc7cb.webp";
    },
    gallery_3() {
      return this.$cdnUrl + "/upload/6676afe735707.webp";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "insurance",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.$toast.success(" بیمه آنلاین شما با موفقیت ساخته شد.");
          this.setCreatedQrID(data.data.id);
          this.setQrType("insurance");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
              }, 2000);
            });

            this.$refs.qrShop.handleQrType();
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    qrUpdate() {
      this.loading = true;

      this.cardTexts.insurance.items = [];
      const data = new FormData();

      data.append("type", "insurance");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data)
        .then((res) => {
          this.$toast.success("کیوآر بیمه آنلاین شما باموفقیت ویرایش شد.");
          if (this.e6 === 3) {
            this.e6++;
            this.qrShow = 0;
            setTimeout(() => {
              this.$refs.qrCanvas.appendCanvas(this.info.link);
            }, 500);
            setTimeout(() => {
              this.qrUpdate();
            });
          }
        })
        .catch((err) => {
          console.log("failed to update qr: ", err);
          this.$toast.error("خطا در ذخیره/ویرایش کیوآر");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateShopSettings() {
      this.loading = true;

      this.$refs.qrShop.setCartSetting().finally(() => {
        this.loading = false;
        this.goto("qr/list");
      });
    },
    clearDefaults() {
      this.cardTexts = {
        pdf: [
          {
            name: "",
            images: [],
          },
        ],
        banner: undefined,
        blog: undefined,
        service: undefined,
        video_gallery: undefined,
        gallery: undefined,
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        visitName: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: null }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: null,
        email: null,
        fax: null,
        location: null,
        city: null,
        codePostal: null,
        province: null,
        country: null,
        website: null,
        socialMedia: {},
        aboutUs: null,
        copyright: null,
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: null,
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        PicSelector: {
          title: "گالری عکس",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            gallery: [
              {
                name: "گالری عکس",
                images: [],
              },
            ],
          },
          sectionColor: {
            backGround: "linear-gradient(to right , #FF000062, #FF000075)",
            text: "#fff",
          },
          items: [],
        },
        Service: {
          title: "خدمات",
          slider: false,
          description:
            "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      };
    },
    // savePageTemplate(input) {
    //   this.templateLoading = true
    //
    //   const ssc = new StoreShopContent(this.createQrID)
    //   ssc.storeCategories(input.product.items)
    //     .then(data => {
    //       this.$toast.success('دسته‌بندی‌های مدل نمونه با موفقیت ذخیره شدند.')
    //       console.log('save template categories: ', data)
    //
    //       ssc.storeProductFromTemplateModel(data.data, input.product.items)
    //         .then(data => {
    //           this.$root.$emit('fetchCategories')
    //           console.log('storeProductFromTemplateModel: ', data)
    //           this.$toast.success('محصولات مدل نمونه با موفقیت ذخیره شدند.')
    //         })
    //         .catch(err => {
    //           console.log('failed to save template model products: ', err)
    //           this.$toast.error('خطا در ذخیره سازی محصولات مدل نمونه!')
    //         })
    //     })
    //     .catch(err => {
    //       console.log('failed to save template model categories: ', err)
    //       this.$toast.error('خطا در ذخیره سازی دسته‌بندی‌های مدل نمونه!')
    //     })
    //     .finally(() => {
    //       let obj = {...input}
    //       obj.product.items = []
    //       this.cardTexts = {...obj}
    //       this.templateLoading = false
    //     })
    // }
  },

  beforeDestroy() {
    this.setCreatedQrID(null);
    this.setQrType(null);
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
